import jQueryBridget from 'jquery-bridget'
import Flickity from 'flickity'

export default {
  init() {
    // JavaScript to be fired on the about us page
    Flickity.setJQuery( $ );
    jQueryBridget( 'flickity', Flickity, $ );

    $('.gallery').flickity({
      cellAlign: 'center',
      wrapAround: true,
      autoPlay: true,
      pageDots: false,
      imagesLoaded: true,
      adaptiveHeight: true,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-flex.js